<app-voucher-titulo></app-voucher-titulo>

<div class="container">
    <p class="lead text-center text-success">Atenção! Guarde seu voucher.</p>
    <p>Caso a transferência bancária não seja concluída, o valor em pontos será automáticamente estornado.</p>
    <button type="button" 
            (click)="mainService.loginService.doLogout()"
            class="btn btn-default">Encerrar Acesso
    </button>
</div>


// WEBPACK FOOTER //
// ./src/app/voucher/voucher-sucesso/voucher-sucesso.component.html